// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"387":"6d414a5b","509":"9641e1c8","614":"9641e1c8"}[chunkId] + ".chunk.css";
};